import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TaskCount } from '../../../../api/models/task';
import { TasksService } from '../../../../api/services/tasks.service';

@Component({
  selector: 'app-tasks-filter',
  templateUrl: './tasks-filter.component.html',
  styleUrls: ['./tasks-filter.component.scss']
})
export class TasksFilterComponent implements OnInit {

  @Input() openTasks: TaskCount[];
  @Input() projectName: string;
  @Input() accountNumber: string;
  @Input() projectId: string;

  @Output() appliedFilter = new EventEmitter<any>();
  
  selected = 'all';
  orderTasksCount: number = 0;
  ROGTaskCount: number = 0;

  constructor(private tasksService: TasksService) {
    this.tasksService.refreshTasksCount.subscribe(value => {
      if(value){ this.setOpenTasks(); }
    });
   }

  filter(option: string) {
    if (this.selected === option) {
      this.selected = 'all';
    } else {
      this.selected = option;
    }
    this.appliedFilter.emit({
      type: 'task',
      filter: this.selected
    });
    if (this.selected !== 'all') {
      window.scrollBy(0, 1000 - window.scrollY);
    }
  }

  ngOnInit() {
    this.setOpenTasks();
  }

  setOpenTasks() {
    this.tasksService.getTasksCountByProject(this.projectId, this.projectName, this.accountNumber).subscribe(tasksCount => {
      this.openTasks = tasksCount;
      if(this.openTasks && this.openTasks.length){
        this.setTaskCount();
      } else {
        this.ROGTaskCount = 0;
        this.orderTasksCount = 0;
      }
    });
  }
    
  setTaskCount() {
    let total = 0;
    this.openTasks.forEach(tasksCount => {
      if(tasksCount.taskType == "RECEIPT OF GOODS"){
        this.ROGTaskCount = tasksCount.count;
      } else {
        total = total + tasksCount.count;
      }
      this.orderTasksCount = total;
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/dashboard-my-oasis-detail/tasks-filter/tasks-filter.component.ts